import React from 'react'
import styled, { css } from 'styled-components'
import { motion } from 'framer-motion'

const StyledSvg = styled.svg<{ draw: boolean }>`
  /* overflow: visible !important;

  @keyframes dash {
    from {
      stroke-dashoffset: 822;
    }
    to {
      stroke-dashoffset: 0;
    }
  }

  .test {
    fill: none;
    stroke-dasharray: 822;
    stroke-dashoffset: 822;
    transition: all 0.3 ease-in-out;

    & stop {
      transition: all 0.3 ease-in-out;
      & stop-color {
        transition: all 0.3 ease-in-out;
      }
    }

    &:hover {
      transition: all 0.3 ease-in-out;
    }
  }

  .test {
    ${(props) =>
    props.draw &&
    css`
      stroke: #e9c080;
      stroke-width: 2;
      animation: dash 1.5s linear forwards;
      & path {
        fill: none !important;
      }
    `}
  } */

  &:hover {
    opacity: 0.8;
  }
`

const Logo = ({ hovered }: any) => (
  <StyledSvg
    xmlns="http://www.w3.org/2000/svg"
    width="127"
    height="66"
    fill="none"
    viewBox="0 0 127 66"
    draw={hovered}
  >
    <motion.g className="test">
      <motion.path
        fill="url(#paint0_linear)"
        d="M52.323 33.92c-.329-.27-.712-.541-1.04-.866a110.457 110.457 0 00-2.85-2.38c-5.972-4.977-12.163-10.063-11.725-18.07.11-2.433.603-4.597 1.37-6.437 1.644-3.354 4.493-5.085 8.438-5.085 6.629.054 9.971 4.923 10.026 14.39 0 2.38-.22 4.49-.603 6.33-.164.703-.329 1.406-.602 2.11-.275.703-.603 1.622-.932 2.218-.877 1.623-1.534 2.434-2.74 3.678 1.59-.487 3.233-1.136 4.712-2.164 2.028-1.406 3.452-2.488 4.931-5.193 1.096-2.326 1.644-4.544 1.644-6.763 0-5.518-2.082-9.791-6.191-12.658C53.802 1.028 50.406 0 46.625 0c-2.356 0-4.602.379-6.63 1.19-5.752 1.785-9.423 6.492-9.752 12.66v.432c-.219 8.602 5.26 13.092 10.52 17.42 1.479 1.244 3.123 2.434 4.712 3.624 4.876 3.679 9.916 7.412 11.724 12.551.439 1.298.439 2.76.493 3.084.165 5.247-.986 8.439-3.451 10.928-1.863 1.893-4.383 2.867-7.506 2.92-7.013-.053-10.63-4.976-10.63-14.66 0-3.462.494-6.383 1.37-8.602 1.37-3.137 2.192-4.327 3.726-6.167-2.137.595-4.493 1.407-6.465 3.084-3.506 2.921-5.26 6.816-5.26 11.469 0 5.41 2.137 9.683 6.356 12.659 3.068 2.164 6.739 3.246 10.793 3.246 3.123 0 5.917-.65 8.438-1.84 5.314-2.272 8.601-7.032 8.71-12.821.056-7.952-6.026-12.875-11.45-17.257z"
      />
    </motion.g>

    <motion.path
      fill="#fff"
      d="M21.587 15.202c-1.041-.541-2.247-.92-3.561-1.19 2.52-.866 4.163-2.327 5.04-4.437.329-.757.493-1.514.493-2.218 0-2.542-1.26-4.382-3.726-5.518C18.3 1.136 16.438.757 14.3.757H0v1.245h3.945v26.67H0v1.244h14.574c4.273 0 7.396-1.298 9.369-3.949 1.04-1.406 1.534-2.921 1.534-4.544 0-2.76-1.315-4.869-3.89-6.221zM8.657 2.056h4.109c3.397 0 5.314 1.514 5.698 4.544.055.379.11.757.11 1.19 0 2.218-.877 3.841-2.63 4.869-.932.541-1.973.811-3.178.811h-4.11V2.056zm8.93 25.426c-1.04.812-2.301 1.19-3.726 1.19h-5.15V14.77h5.096c2.903 0 4.876 1.244 5.862 3.733.384.92.548 1.893.548 2.921-.055 2.65-.877 4.652-2.63 6.059zM94.017 28.726c-.164-.054-.328-.054-.548-.054h-1.588l-7.78-12.55c3.122-.812 5.204-2.435 6.3-4.924.384-.92.603-1.893.603-2.867 0-2.434-1.041-4.382-3.178-5.842-1.753-1.19-3.89-1.732-6.41-1.732H66.623v1.245h3.89v26.67h-3.89v1.244H79.06v-1.244h-3.89V16.554h4.164l7.67 13.362h7.561c.055-.703-.164-1.136-.548-1.19zM83.443 13.957c-.986.812-2.192 1.19-3.616 1.19H75.17V2.057h4.493c2.739 0 4.602 1.136 5.643 3.462.383.92.603 1.948.603 2.975 0 2.38-.822 4.166-2.466 5.464zM114.179 16.77v1.245h4.438v8.006c-1.972 1.84-4.328 2.813-7.013 2.922-5.917 0-9.094-3.733-9.642-11.253a32.956 32.956 0 01-.11-2.38c0-8.06 2.575-12.551 7.725-13.525.658-.108 1.26-.162 1.918-.162 3.397 0 5.862 1.028 7.396 3.03.986 1.298 1.808 3.245 2.466 5.788h1.369l-.219-9.63-4.438.92C115.988.703 113.741.216 111.276.216c-4.109 0-7.561 1.299-10.41 3.895-3.068 2.814-4.602 6.438-4.602 10.982 0 5.302 1.917 9.414 5.752 12.227 2.74 2.001 5.808 3.03 9.26 3.03 2.575 0 4.876-.542 6.903-1.678.164-.108.329-.162.438-.216l4.603 1.406V17.961h3.616v-1.19h-12.657zM87.114 50.582c-.548-.325-2.466-1.19-5.808-2.65-3.013-1.245-4.876-2.544-5.698-3.896a4.587 4.587 0 01-.548-2.218c0-2.056 1.041-3.516 3.178-4.328.931-.379 1.918-.54 3.013-.54 2.85 0 4.986.919 6.466 2.758 1.04 1.244 1.534 2.813 1.479 4.653h1.644v-8.494c-.877 0-1.37.27-1.48.812-.055.216-.11.487-.11.811-2.52-1.244-5.314-1.893-8.327-1.893-3.726 0-6.63.974-8.712 2.921-1.424 1.352-2.082 2.921-2.082 4.76 0 2.706 1.59 4.924 4.767 6.655.603.324 2.52 1.19 5.808 2.65 3.013 1.299 4.985 2.651 5.752 4.004.384.703.603 1.515.603 2.326 0 2.272-1.15 3.895-3.397 4.869-1.04.433-2.191.65-3.452.65-4.93 0-7.78-2.706-8.601-8.116-.055-.378-.055-.703-.11-1.028h-1.643v10.117c.821 0 1.314-.216 1.479-.703.055-.27.11-.758.11-1.407 2.63 1.677 5.643 2.489 9.04 2.489 3.944 0 7.012-1.028 9.204-3.03 1.534-1.46 2.301-3.192 2.301-5.193 0-2.868-1.644-5.194-4.876-6.98zM111.988 64.377c-4.712 0-7.78-2.488-9.15-7.465-.493-1.84-.767-3.95-.767-6.276 0-6.167 1.753-10.333 5.315-12.388 1.424-.866 3.013-1.245 4.821-1.245 4.986.054 8.273 2.705 9.917 7.953h1.315l-.165-9.089c-.767 0-1.26.217-1.424.704-.055.378-.11.973-.11 1.73-1.917-1.406-4.492-2.326-7.725-2.65-.712-.054-1.424-.108-2.137-.108-5.479 0-9.642 1.893-12.546 5.68-2.027 2.705-3.014 5.788-3.014 9.305 0 4.22 1.425 7.79 4.219 10.711 2.959 2.976 6.739 4.49 11.506 4.49a20.914 20.914 0 009.916-2.65c0 1.352.22 2.164.713 2.326.219.054.493.108.931.108v-9.305h-1.315c-1.698 5.41-5.15 8.17-10.3 8.17z"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="52"
        x2="40.5"
        y1="0"
        y2="66"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E9C080" />
        <stop offset="1" stopColor="#AA7C3E" />
      </linearGradient>
    </defs>
  </StyledSvg>
)

export default Logo
